import React, { useEffect, useState } from "react";

export const taglineSecs = (v: any) => Math.min(12, Math.max(3, Number(v) || 4));

export function RotatingTagline({ site }: { site: any }) {
  const lines: string[] = (site?.taglines?.length ? site.taglines : [site?.tagline]).filter(Boolean);
  const secs = taglineSecs(site?.tagline_interval);
  const [i, setI] = useState(0);
  useEffect(() => {
    if (lines.length < 2) return;
    const t = setInterval(() => setI((n) => (n + 1) % lines.length), secs * 1000);
    return () => clearInterval(t);
  }, [lines.length, secs]);
  if (!lines.length) return null;
  const cur = i % lines.length;
  return (
    <span className="grid mt-1.5 font-wordmark text-[8px] md:text-[9px] max-[380px]:text-[7px] tracking-[0.35em] max-sm:!tracking-[0.1em] uppercase whitespace-nowrap" data-testid="header-tagline" data-current={cur}>
      {lines.map((l, n) => (
        <span key={n} aria-hidden={n !== cur} className={`col-start-1 row-start-1 text-center transition-opacity duration-500 ease-out ${n === cur ? "opacity-70 delay-500" : "opacity-0 delay-0"}`} data-testid={`header-tagline-${n}`}>{l}</span>
      ))}
    </span>
  );
}

export function TaglinesField({ s, set }: { s: any; set: (k: string, v: any) => void }) {
  const lines: string[] = [0, 1, 2, 3].map((n) => (s.taglines || [s.tagline])[n] || "");
  const secs = taglineSecs(s.tagline_interval);
  const up = (n: number, v: string) => set("taglines", lines.map((l, j) => (j === n ? v : l)));
  return (
    <div className="sm:col-span-2 space-y-2" data-testid="site-taglines">
      <span className="eyebrow text-[10px] text-neutral-500">Taglines under the logo — they fade from one to the next (leave a box blank to use fewer)</span>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {lines.map((l, n) => <input key={n} value={l} maxLength={60} onChange={(e) => up(n, e.target.value)} placeholder={`Tagline ${n + 1}`} className="border border-neutral-300 bg-white px-3 py-2.5 text-sm w-full focus:outline-none focus:border-neutral-900" data-testid={`site-tagline-input-${n}`} />)}
      </div>
      <label className="flex items-center gap-4 text-sm pt-1">
        <span className="whitespace-nowrap">Show each for</span>
        <input type="range" min={3} max={12} step={1} value={secs} onChange={(e) => set("tagline_interval", Number(e.target.value))} className="flex-1" data-testid="site-tagline-interval" />
        <span className="w-20 text-right tabular-nums" data-testid="site-tagline-interval-value">{secs} seconds</span>
      </label>
    </div>
  );
}
